import { useState } from "react"
import { getBranchGuestSession, IBranchGuestSession } from "../utils/branchGuestSession"

/**
 * The branch guest session, when branch staff have opened a customer's account to manage their
 * favourites. Read once per mount: it only changes on a full page load.
 */
export function useBranchGuestSession(): IBranchGuestSession | null {
  const [session] = useState(getBranchGuestSession)
  return session
}

/** True when the customer area is being used by branch staff in a guest session */
export function useIsBranchGuest() {
  return Boolean(useBranchGuestSession())
}
